<div class="bg-white text-secondary custom-navbar h-100">
    <div class="container">
        <div class="d-flex">
            <div class="flex-even text-center">
                <a class="nav-link p-2" [routerLink]="'home'" routerLinkActive="active">
                    <div><i class="fa-solid fa-house nav-link-item"></i></div>
                    <div class="nav-link-text">
                        {{ "main.navbar.home" | transloco }}
                    </div>
                </a>
            </div>

            <div class="flex-even text-center">
                <a class="nav-link p-2" [routerLink]="'assignments'" routerLinkActive="active">
                    <div><i class="fa-solid fa-calendar-days nav-link-item"></i></div>
                    <div class="nav-link-text">
                        {{ "main.navbar.assignments" | transloco }}
                    </div>
                </a>
            </div>

            <div class="flex-even text-center">
                <a class="nav-link p-2" [routerLink]="'inbox'" routerLinkActive="active">
                    <div class="d-flex justify-content-center">
                        <div>
                            <div class="position-relative">
                                <i class="fa-solid fa-envelope nav-link-item"></i>

                                <ng-container
                                    *ngIf="(notificationsStateService.notificationsCountSubject$| async) as count">
                                    <!-- Inbox counter badge -->
                                    <span
                                        class="nav-link-count position-absolute top-0 mt-1 start-100 translate-middle badge rounded-pill bg-warning"
                                        *ngIf="count > 0">
                                        {{ count > 99 ? '99+' : count }}
                                        <span class="visually-hidden">unread messages</span>
                                    </span>
                                </ng-container>
                            </div>

                            <div class="nav-link-text">
                                {{ "main.navbar.inbox" | transloco }}
                            </div>
                        </div>

                    </div>

                </a>
            </div>

            <div class="flex-even text-center">
                <a class="nav-link p-2" [routerLink]="'know-how'" routerLinkActive="active">
                    <div><i class="fa-solid fa-file nav-link-item"></i></div>
                    <div class="nav-link-text">
                        {{ "main.navbar.knowHow" | transloco }}
                    </div>
                </a>
            </div>

            <div class="flex-even text-center">
                <a class="nav-link p-2" [routerLink]="'profile'" routerLinkActive="active">
                    <div><i class="fa-solid fa-user nav-link-item"></i></div>
                    <div class="nav-link-text">
                        {{ "main.navbar.profile" | transloco }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>